/* eslint-disable no-nested-ternary */
import { useState } from 'react';

import { Button as MuiButton, Radio } from '@mui/material';

import _ from 'lodash';

import PropTypes from 'prop-types';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const RoomTypesSort = (props) => {    

    const { onRoomSort } = props;

    const [openModal, setOpenModal] = useState(null);

    const [sortBy, setSortByPriceAction] = useState('Sort By');   

    const onModalClose = () => {
        setOpenModal(false);
    };

    const onButtonClick = () => {
        setOpenModal(true);
    };

    const onValueSelect = (value) => {
        setSortByPriceAction(value);
        if (onRoomSort) { 
            onRoomSort(value);
        }        
    };

    return (
        <>
            <div className='room-types-sort-button-container'>
                <MuiButton
                    id="room-sort-button"
                    endIcon={sortBy === 'Sort By' ? <ExpandMoreIcon fontSize="large" /> : null}  
                    onClick={onButtonClick}
                >
                    {sortBy}
                </MuiButton>
                {openModal && (
                    <div>
                        <div className='room-types-sort-overlay' onClick={onModalClose} />

                        <div className='room-types-sort-modal-container'>
                            <div className='room-types-sort-radio-line-item' onClick={() => onValueSelect('Sort By')}>
                                <div id="room-types-sort-default" className='room-types-sort-radio-wrapper'>
                                    <Radio 
                                        id='sort_by'
                                        checked={_.includes(sortBy, 'Sort By')} 
                                        disableRipple 
                                    />
                                </div>
                                <h6 style={{ color: '#fff' }}>{'Default'}</h6>
                            </div>

                            <div className='room-types-sort-radio-line-item' onClick={() => onValueSelect('Price - Low to High')}>
                                <div id="room-types-sort-price-low-to-high" className='room-types-sort-radio-wrapper'>
                                    <Radio
                                        id='sort_by_low_to_high'
                                        checked={_.includes(sortBy, 'Price - Low to High')}
                                        disableRipple
                                    />
                                </div>
                                <h6 style={{ color: '#fff' }}>{'Price - Low to High'}</h6>
                            </div>

                            <div className='room-types-sort-radio-line-item' onClick={() => onValueSelect('Price - High to Low')}>
                                <div id="room-types-sort-price-high-to-low" className='room-types-sort-radio-wrapper'>
                                    <Radio
                                        id='sort_by_high_to_low'
                                        checked={_.includes(sortBy, 'Price - High to Low')}
                                        disableRipple
                                    />
                                </div>
                                <h6 style={{ color: '#fff' }}>{'Price - High to Low'}</h6>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default RoomTypesSort;

RoomTypesSort.propTypes = {    
    onRoomSort: PropTypes.func,
};

